module.exports = __webpack_public_path__ + "static/media/movies-questions.c2bb1b41.csv";